import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import MainLayout from './MainLayout';

const Layout = ({ children }) => (
	<React.Fragment>
		<Helmet title={`Lattice Studios`}>
			<html lang='en' />
		</Helmet>
		<MainLayout>{children}</MainLayout>
	</React.Fragment>
);

Layout.propTypes = {
	children: PropTypes.node.isRequired
};

export default Layout;
